export default __webpack_public_path__ + "static/tree-planting-c9998e0a970e84b4f82b87a076afdadb.jpg";